import { Modal } from "antd";
import React from "react";
import img from "../../../../assets/orgAdmin/batch-created-successfully.svg";
import { Link } from "react-router-dom";

function CreatedSuccessModal({
  createdSuccessFlag,
  setCreatedSuccessFlag,
  setCreateBatchFlag,
  setRefressGetApi,
}) {
  return (
    <Modal
      open={createdSuccessFlag}
      //   onCancel={() => setCreatedSuccessFlag(false)}
      closable={false}
      maskClosable={false}
      footer={null}
      width={500}
    >
      <div className="text-center">
        <img src={img} width={275} className="mx-auto" alt="" />
        <p className="mt-4 text-gray-900 font-semibold text-[1.2rem]">
          Batch Created Successfully!
        </p>
        <p className="mt-1 sub-text-color text-[.92rem] max-w-[400px] mx-auto">
          The batch has been created successfully. You can now manage students,
          jobs, and interviews.
        </p>
        <div className="mt-3 flex sm:flex-row flex-col gap-x-3 gap-y-2">
          <button
            onClick={() => {
              setCreatedSuccessFlag(false);
              setCreateBatchFlag(false);
              setRefressGetApi((prev) => prev + 1);
            }}
            className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          >
            Go back
          </button>
          {/* <Link to={`/batches/`}> */}
          <button
            onClick={() => {
              setCreatedSuccessFlag(false);
              setCreateBatchFlag(false);
              setRefressGetApi((prev) => prev + 1);
            }}
            className="btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full"
          >
            View batches
          </button>
          {/* </Link> */}
        </div>
      </div>
    </Modal>
  );
}

export default CreatedSuccessModal;
